


























import {Component, Vue} from 'vue-property-decorator';

@Component({
    props     : {
        type : String,
        items: Array,
    },
    components: {
        Item      : () => import("@/components/Infrastructure/Item.vue"),
        OrderModal: () => import("@/components/Infrastructure/Order/OrderModal.vue"),
    }
})
export default class Infrastructure extends Vue {
    private selectedItem = {};

    private onItemSelect(event: any) {
        this.selectedItem = event.item;
    }
}
